const CaruselCard = (target) => {
  // https://kenwheeler.github.io/slick/

  const SLIDER_WRAPPER_DATA_SELECTOR = '[data-slider-wrap]';
  const SLIDER_NEXT_BUTTON_SELECTOR = '[data-slider-next]';
  const SLIDER_PREV_BUTTON_SELECTOR = '[data-slider-prev]';

  const sliderParams = {
    dots: false,
    speed: 300,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const initSlider = ($el, params) => {
    $el.slick(params);
  };

  $('body').find(target).each((_, el) => {
    const $el = $(el);
    const params = $.extend({}, sliderParams, $(this).data('slider'))

    params.prevArrow = $el.closest(SLIDER_WRAPPER_DATA_SELECTOR).find(SLIDER_PREV_BUTTON_SELECTOR);
    params.nextArrow = $el.closest(SLIDER_WRAPPER_DATA_SELECTOR).find(SLIDER_NEXT_BUTTON_SELECTOR);

    initSlider($el, params);
  })
}

export default CaruselCard;



// WEBPACK FOOTER //
// ./scripts/components/CaruselCard.js